export default __webpack_public_path__ + "static/media/accounting.1da2a98c.svg";